import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnPlayerVSPlayer } from '..';

type FormData = FormDataOf<typeof disneyEspnPlayerVSPlayer>;

export const buildBannerType = (formData: FormData): string => {
  const { league } = formData;
  if (!league) return 'espn/espn-vs/futbol';
  return `espn/espn-vs/futbol/${league}/miniatura`;
};
